// src/pages/Branch/components/CreateBranchForm.jsx
import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Typography,
  Grid,
  DatePicker,
  InputNumber,
  Checkbox,
  Tooltip,
  Upload,
  Input,
  Card,
  Radio,
  Select,
} from "antd";
import { InfoCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { App } from "antd";
import { useForm } from "antd/es/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { createOrUpdateBranch, fetchBranchList } from "../branchThunks";
import { fetchSingleInstitutionDetails } from "../../../../store/commonThunks/lookups";
import { setSelectedBranch, setIsEditBranch } from "../branchSlice";
import { getDays, getIndustries } from "../../../../lib/industries";
import moment from "moment";
import { getAccessType } from "../../../../lib/functions";
import { getISOFromCountryName, indianStates } from "../../../../lib/currency";
const { Option } = Select;

const { Title } = Typography;
const { useBreakpoint } = Grid;
const { TextArea } = Input;

const CreateBranchForm = ({ authInfo }) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [form] = useForm();
  let [access_type, access_type_set] = useState("");

  const { isEdit, selectedBranch } = useSelector((s) => s.branchManage);
  const lookups = useSelector((state) => state.lookups);
  const crossBranchSyncEnabled =
    lookups?.institutionData?.enable_cross_branch_item_sync === "yes";

  const defaultCountry = getISOFromCountryName(authInfo?.country);
  const isIndiaCompany =
    authInfo?.country?.trim()?.toLowerCase() === "india";


  useEffect(() => {
    if (!isIndiaCompany) {
      form.setFieldsValue({
        province: null,
      });
    }
  }, [isIndiaCompany, form]);

  useEffect(() => {
    dispatch(fetchSingleInstitutionDetails());
  }, [dispatch]);

  useEffect(() => {
    if (isEdit && selectedBranch) {

      const mapped = {
        branch_name: selectedBranch.name,
        branch_title: selectedBranch.title,
        branch_address: selectedBranch.address,
        branch_company_type: selectedBranch.company_type,

        margin_rate: selectedBranch.margin_rate,
        vat_percent: selectedBranch.branch_item_tax,

        branch_email: selectedBranch.branch_company_email,
        branch_phone: selectedBranch.branch_phone_no,
        branch_website: selectedBranch.branch_web_site,

        trade_license: selectedBranch.branch_trade_license_no,
        trade_license_expiry: selectedBranch.branch_trade_license_expiry
          ? dayjs(selectedBranch.branch_trade_license_expiry)
          : null,

        vat_license: selectedBranch.branch_vat_license,

        dha_moh_no: selectedBranch.dha_moh_no,
        dha_moh_expiry: selectedBranch.dha_moh_expiry
          ? dayjs(selectedBranch.dha_moh_expiry)
          : null,

        branch_gln_no: selectedBranch.branch_gln_no,
        branch_gln_expiry: selectedBranch.branch_gln_no_expiry
          ? dayjs(selectedBranch.branch_gln_no_expiry)
          : null,
        company_prefix_length: selectedBranch.company_prefix_length,

        po_box: selectedBranch.branch_po_box,
        return_policy_days: selectedBranch.branch_return_policy,
        // replace_policy_days: selectedBranch.branch_replace_policy,

        time_zone: selectedBranch.branch_time_zone,

        print_type: selectedBranch.branch_print_type,
        voucher_receipt: selectedBranch.branch_is_voucher_receipt,
        is_warehouse: selectedBranch.branch_is_warehouse,
        cal_type: selectedBranch.branch_is_cal_type,
        serial_enabled: selectedBranch.branch_is_serial,
        auto_challan: selectedBranch.branch_is_auto_challan,
        minus_stock_sale: selectedBranch.branch_is_minus_stock_sale,

        annual_leave_type: Number(selectedBranch.branch_annual_leave_type),
        annual_leave_days: selectedBranch.branch_annual_leave_days,

        weekend_days: selectedBranch.branch_weekend_days
          ? selectedBranch.branch_weekend_days.split(",").map(Number)
          : [],

        reset_accrued_leave: selectedBranch.branch_shouldResetAccruedLeave,
        leaves_carry_forward: selectedBranch.branch_leaves_carry_forward,

        branch_desc: selectedBranch.branch_description,
        province: selectedBranch.province || null,
        // enableDetails: !!(
        //   selectedBranch.branch_logo ||
        //   selectedBranch.branch_stamp ||
        //   selectedBranch.branch_signature ||
        //   selectedBranch.branch_vat_license ||
        //   selectedBranch.branch_trade_license_no
        // ),

        enableDetails: selectedBranch.branch_info === 1,
      };

      if (selectedBranch.branch_logo) {
        mapped.branch_logo = [
          {
            uid: "-1",
            name: selectedBranch.branch_logo.split("/").pop(), // extract file name
            status: "done",
            url: selectedBranch.branch_logo,
          },
        ];
      } else {
        mapped.branch_logo = [];
      }

      if (selectedBranch.branch_stamp) {
        mapped.branch_stamp = [
          {
            uid: "-2",
            name: selectedBranch.branch_stamp.split("/").pop(),
            status: "done",
            url: selectedBranch.branch_stamp,
          },
        ];
      } else {
        mapped.branch_stamp = [];
      }

      if (selectedBranch.branch_signature) {
        mapped.branch_signature = [
          {
            uid: "-3",
            name: selectedBranch.branch_signature.split("/").pop(),
            status: "done",
            url: selectedBranch.branch_signature,
          },
        ];
      } else {
        mapped.branch_signature = [];
      }

      form.setFieldsValue(mapped);
    }
  }, [isEdit, selectedBranch]);

  useEffect(() => {
    const access = getAccessType("branch_entry");
    access_type_set(access);
  }, []);

  const handleCancel = () => {
    dispatch(setSelectedBranch(null));
    dispatch(setIsEditBranch(false));
    navigate(-1);
  };

  const getFilteredIndustries = () => {
    const industries = getIndustries();
    const sub = authInfo?.subscription;

    const forthPlans = [
      "ForthERP_Basic",
      "ForthERP_Standard",
      "ForthERP_Pro",
      "ForthBooks_Basic",
      "ForthBooks_Standard",
      "ForthBooks_Pro",
      "HRPayroll_Pro",
      "HRPayroll_Standard",
      "HRPayroll_Basic",
      "ForthCRM_Basic",
      "ForthCRM_Standard",
      "ForthCRM_Pro",
    ];

    const pharmaPlans = [
      "PharmaERP_Basic",
      "PharmaERP_Standard",
      "PharmaERP_Pro",
      "PharmaBooks_Basic",
      "PharmaBooks_Standard",
      "PharmaBooks_Pro"
    ];

    if (forthPlans.includes(sub)) {
      return industries.filter(
        (item) =>
          !["Healthcare", "Pharmacy", "Drug Store"].includes(item.value)
      );
    }

    if (pharmaPlans.includes(sub)) {
      return industries.filter((item) =>
        ["Healthcare", "Others", "Pharmacy", "Drug Store"].includes(item.value)
      );
    }

    if (sub === "SuperERP") {
      return industries;
    }

    return industries;
  };

  const handleSave = async (values) => {
    try {
      // ✅ validations before mapping

      if (authInfo?.trial_mode == "yes") {
        const userName = authInfo?.userInfo?.name || "User";

        Swal.fire({
          icon: "warning",
          title: `Hi ${userName}!`,
          text: "You are currently using the Free version. Please upgrade your plan .",
        });

        return;
      }

      if (!values.branch_name?.trim()) {
        modal.error({ title: "Branch name is required" });
        return;
      }
      if (values.branch_name.length > 100) {
        modal.error({ title: "Branch name cannot exceed 100 characters" });
        return;
      }
      if (!values.branch_title?.trim()) {
        modal.error({ title: "Branch title is required" });
        return;
      }
      if (values.branch_title.length > 100) {
        modal.error({ title: "Branch title cannot exceed 100 characters" });
        return;
      }
      if (!values.branch_address?.trim()) {
        modal.error({ title: "Branch address is required" });
        return;
      }
      if (/^\d+$/.test(values.branch_address.trim())) {
        modal.error({ title: "Branch address cannot be numbers only" });
        return;
      }
      if (!values.branch_company_type) {
        modal.error({ title: "Select Company Type" });
        return;
      }

      // Email format check
      if (values.branch_email) {
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
          values.branch_email
        );
        if (!isValidEmail) {
          modal.error({ title: "Invalid Email Format" });
          return;
        }
      }

      // Length constraints (similar to old UI)
      const MAX_LENGTHS = {
        branch_phone: 20,
        branch_email: 40,
        branch_website: 50,
        vat_percent: 10,
        vat_license: 20,
        dha_moh_no: 20,
        trade_license: 20,
        po_box: 10,
        branch_gln_no: 30,
        branch_desc: 60,
      };

      for (const [field, maxLen] of Object.entries(MAX_LENGTHS)) {
        const val = values[field];
        if (val && String(val).trim().length > maxLen) {
          modal.error({
            title: `${field} cannot exceed ${maxLen} characters.`,
          });
          return;
        }
      }

      // ✅ mapping
      const mapped = {
        name: values.branch_name,
        title: values.branch_title || values.branch_name,
        address: values.branch_address,
        id: selectedBranch?.id || 0,
        company_prefix_length: values.company_prefix_length,
        company_type: values.branch_company_type,
        margin_rate: values.margin_rate,
        branch_item_tax: values.vat_percent,
        branch_trade_license_no: values.trade_license,
        branch_trade_license_expiry: values.trade_license_expiry
          ? values.trade_license_expiry.format("YYYY-MM-DD HH:mm:ss")
          : null,
        branch_vat_license: values.vat_license,
        branch_phone_no: values.branch_phone,
        branch_company_email: values.branch_email,
        branch_web_site: values.branch_website,
        branch_po_box: values.po_box,
        branch_time_zone: values.time_zone,
        branch_return_policy: values.return_policy_days,
        // branch_replace_policy: values.replace_policy_days,
        branch_print_type: values.print_type,
        branch_is_voucher_receipt: values.voucher_receipt || "no",
        branch_is_warehouse: values.is_warehouse,
        branch_is_cal_type: values.cal_type,
        branch_is_serial: values.serial_enabled,
        branch_is_auto_challan: values.auto_challan,
        branch_is_minus_stock_sale: values.minus_stock_sale,
        branch_description: values.branch_desc,
        branch_annual_leave_type: Number(values.annual_leave_type) || 0,
        branch_annual_leave_days: values.annual_leave_days,
        branch_weekend_days: Array.isArray(values.weekend_days)
          ? values.weekend_days.join(",")
          : values.weekend_days || "",
        branch_shouldResetAccruedLeave: values.reset_accrued_leave || "no",
        branch_leaves_carry_forward: values.leaves_carry_forward || 0,
        branchUpdateIndex: 0,
        branch_info: values.enableDetails ? 1 : 0,
        province: values.province || null,
        action: isEdit ? "update" : "create",
        branch_gln_no: values.branch_gln_no,
        branch_gln_no_expiry: values.branch_gln_expiry
          ? values.branch_gln_expiry.format("YYYY-MM-DD HH:mm:ss")
          : null,
        copy_synced_products:
          !isEdit && values.copy_synced_products ? "true" : undefined,
      };

      // ✅ convert to FormData
      const formData = new FormData();
      Object.entries(mapped).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
          formData.append(key, val);
        }
      });

      if (values.branch_logo?.[0]?.originFileObj) {
        formData.append("logo", values.branch_logo[0].originFileObj);
      }
      if (values.branch_stamp?.[0]?.originFileObj) {
        formData.append("stamp", values.branch_stamp[0].originFileObj);
      }
      if (values.branch_signature?.[0]?.originFileObj) {
        formData.append("signature", values.branch_signature[0].originFileObj);
      }

      // ✅ dispatch and check response
      const res = await dispatch(createOrUpdateBranch(formData)).unwrap();

      // ✅ Use SweetAlert2 instead of antd modals
      if (res.error) {
        const safeMessages = [
          "Branch number limit exceeded",
          "Branch Name Already Exists !!!",
        ];

        if (safeMessages.includes(res.message)) {
          Swal.fire({
            title: res.message,
            icon: "warning",
            confirmButtonColor: "#3085d6",
          });
        } else {
          Swal.fire({
            title: "Something went wrong. Please try again later.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
        return;
      }

      Swal.fire({
        title: isEdit
          ? "Branch updated successfully"
          : "Branch created successfully",
        icon: "success",
        confirmButtonColor: "#3085d6",
      });

      dispatch(setSelectedBranch(null));
      dispatch(setIsEditBranch(false));
      navigate("/settings/branch-manage");
      dispatch(fetchBranchList());
    } catch (err) {
      Swal.fire({
        title: err.message || "Save failed",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  const timeZoneOptions = moment.tz.names().map((tz) => ({
    value: tz,
    label: `${tz} - ${moment().tz(tz).format("YYYY-MM-DD HH:mm")}`,
  }));

  return (
    <div className="branch-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEdit ? "Update Branch" : "Create New Branch"}
      </Title>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        style={{ maxWidth: "1400px" }}
        colon={false}
        requiredMark={(label, { required }) =>
          required ? (
            <>
              {label} <span style={{ color: "#ff4d4f" }}>*</span>
            </>
          ) : (
            label
          )
        }
      >
        {/* Basic Info */}
        <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
          <Form.Item
            label="Branch Name"
            name="branch_name"
            rules={[{ required: true, message: "Branch Name is required" }]}
            style={{ flex: 1, minWidth: 220 }}
          >
            <Input data-testid="branch-name" placeholder="Branch name" />
          </Form.Item>

          <Form.Item
            label="Branch Title"
            name="branch_title"
            rules={[{ required: true, message: "Branch Title is required" }]}
            style={{ flex: 1, minWidth: 220 }}
          >
            <Input data-testid="branch-title" placeholder="Branch title" />
          </Form.Item>

          <Form.Item
            label="Branch Address"
            name="branch_address"
            rules={[{ required: true, message: "Branch Address is required" }]}
            style={{ flex: 1, minWidth: 220 }}
          >
            <Input data-testid="branch-address" placeholder="Branch address" />
          </Form.Item>

          <Form.Item
            label="Industry"
            name="branch_company_type"
            rules={[{ required: true, message: "Industry Type is required" }]}
            style={{ flex: 1, minWidth: 220 }}
          >
            <Select
              showSearch
              placeholder="Select Industry"
              options={getFilteredIndustries()}
              data-testid="branch-company-type"
            />
          </Form.Item>

          {isIndiaCompany && (
            <Form.Item
              label="State"
              name="province"
              rules={[{ required: true, message: "State is required" }]}
              style={{ minWidth: 220 }}
              data-testid="branch-state"
            >
              <Select placeholder="Select State" showSearch>
                {indianStates.map((state) => (
                  <Option key={state.code} value={state.name}>
                    {state.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item label="Branch Transfer Margin Rate (%)" name="margin_rate">
            <InputNumber
              data-testid="branch-margin-rate"
              min={0}
              style={{ minWidth: 220 }}
              onFocus={() => {
                form.setFieldValue("margin_rate", undefined);
              }}
            />
          </Form.Item>
        </div>

        {!isEdit && crossBranchSyncEnabled && (
          <Form.Item
            name="copy_synced_products"
            valuePropName="checked"
            style={{ marginBottom: 8 }}
          >
            <Checkbox data-testid="branch-copy-synced-products">
              Copy existing synced products into this branch{" "}
              <Tooltip title="Every product already shared across your other branches via Cross-Branch Item Sync will be created here too, staying in sync going forward.">
                <InfoCircleOutlined style={{ marginLeft: 6 }} />
              </Tooltip>
            </Checkbox>
          </Form.Item>
        )}

        {/* <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
          {isIndiaCompany && (
            <Form.Item
              label="State"
              name="province"
              rules={[{ required: true, message: "State is required" }]}
              style={{ minWidth: 220 }}
            >
              <Select placeholder="Select State" showSearch>
                {indianStates.map((state) => (
                  <Option key={state.code} value={state.name}>
                    {state.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item label="Branch Transfer Margin Rate (%)" name="margin_rate">
            <InputNumber
              data-testid="branch-margin-rate"
              min={0}
              style={{ minWidth: 220 }}
            />
          </Form.Item>

        </div> */}

        {/* Toggle advanced */}
        <Form.Item
          name="enableDetails"
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Checkbox>
            Add a distinct logo and other details for branch{" "}
            <Tooltip title="Enable this option to include branch-specific details on the invoice, such as a distinct logo, branch name, address, and contact information.">
              <InfoCircleOutlined style={{ marginLeft: 6 }} />
            </Tooltip>
          </Checkbox>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.enableDetails !== curr.enableDetails
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("enableDetails") && (
              <Card title="Advanced Details" style={{ marginBottom: "24px" }}>
                <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                  <Form.Item
                    label="Email"
                    name="branch_email"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Input placeholder="Company Email" />
                  </Form.Item>

                  <Form.Item
                    label="Contact No"
                    name="branch_phone"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <PhoneInput
                      country={defaultCountry}
                      value={form.getFieldValue("branch_phone")}
                      onChange={(value) =>
                        form.setFieldsValue({ branch_phone: value })
                      }
                      inputStyle={{
                        width: "100%",
                      }}
                      placeholder="Contact no"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Website"
                    name="branch_website"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Input placeholder="Website" />
                  </Form.Item>

                  <Form.Item
                    label="Time Zone"
                    name="time_zone"
                    rules={[
                      { required: true, message: "Time Zone is required" },
                    ]}
                    style={{ flex: 1, minWidth: 400, maxWidth: 600 }}
                  >
                    <Select
                      showSearch
                      placeholder="Select Time Zone"
                      options={timeZoneOptions}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  {/* <Form.Item
                    label="VAT %"
                    name="vat_percent"
                    style={{ flex: 1, minWidth: 160 }}
                  >
                    <InputNumber min={0} style={{ width: "100%" }} />
                  </Form.Item> */}

                  <Form.Item
                    label="Trade License No"
                    name="trade_license"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Trade License Expiry"
                    name="trade_license_expiry"
                    style={{ flex: 1, minWidth: 220 }}
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>

                  <Form.Item
                    label={isIndiaCompany ? "GSTIN" : "VAT Registration No."}
                    name="vat_license"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Input />
                  </Form.Item>

                  {(authInfo?.company_type === "Drug Store" ||
                    authInfo?.company_type === "Pharmacy" ||
                    authInfo?.subscription === "SuperERP") && (
                      <>
                        <Form.Item
                          label="DHA/MOH License No."
                          name="dha_moh_no"
                          style={{ flex: 1, minWidth: 260 }}
                        >
                          <Input placeholder="DHA/MOH No." />
                        </Form.Item>

                        <Form.Item
                          label="DHA/MOH Expiry"
                          name="dha_moh_expiry"
                          style={{ flex: 1, minWidth: 220 }}
                        >
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>

                        <Form.Item
                          label="GLN No."
                          name="branch_gln_no"
                          style={{ flex: 1, minWidth: 260 }}
                        >
                          <Input placeholder="GLN No." />
                        </Form.Item>

                        <Form.Item
                          label="GLN No Expiry"
                          name="branch_gln_expiry"
                          style={{ flex: 1, minWidth: 220 }}
                        >
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>

                        <Form.Item
                          label="Company Prefix Length"
                          name="company_prefix_length"
                          style={{ flex: 1, minWidth: 260 }}
                          rules={[
                            {
                              type: "number",
                              min: 6,
                              max: 12,
                              message: "Company Prefix Length must be between 6 and 12",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={12}
                            style={{ width: "100%" }}
                            placeholder="Enter company prefix length"
                          />
                        </Form.Item>
                      </>
                    )}

                  <Form.Item
                    label="PO Box"
                    name="po_box"
                    style={{ flex: 1, minWidth: 220 }}
                  >
                    <Input />
                  </Form.Item>
                  {/* 
                  <Form.Item
                    label="Return Policy (Days)"
                    name="return_policy_days"
                    style={{ flex: 1, minWidth: 220 }}
                  >
                    <InputNumber min={0} style={{ width: "100%" }} />
                  </Form.Item> */}


                  <Form.Item
                    label={isIndiaCompany ? "Casual Leave Type" : "Annual Leave Type"}
                    name="annual_leave_type"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Select
                      options={[
                        { value: 1, label: "Calendar Days" },
                        { value: 2, label: "Working Days" },
                      ]}
                      placeholder={isIndiaCompany ? "Select Casual Leave Type" : "Select Annual Leave Type"}
                    />
                  </Form.Item>

                  <Form.Item
                    label={isIndiaCompany ? "Casual Leave Days" : "Annual Leave Days"}
                    name="annual_leave_days"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <InputNumber min={0} style={{ width: "100%" }}
                      onFocus={() => {
                        form.setFieldValue("annual_leave_days", undefined);
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Weekend Days"
                    name="weekend_days"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Choose weekend Days"
                      options={getDays()}
                      maxTagCount="responsive"
                    />
                  </Form.Item>

                  {/* Radio replacements */}
                  {/* Invoice Print Type */}
                  <Form.Item
                    label="Invoice Print Type"
                    name="print_type"
                    initialValue="a4"

                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="a4">A4</Radio>
                      <Radio value="a5">1/2 of A4</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* <Form.Item label="Voucher Receipt" name="voucher_receipt" style={{ flex: 1, minWidth: 200 }}>
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item> */}

                  {/* Is Warehouse? */}
                  <Form.Item
                    label="Is Warehouse?"
                    name="is_warehouse"
                    initialValue="no"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* Vat & Discount on Bill Type? */}
                  <Form.Item
                    label="Vat & Discount on Bill Type?"
                    name="cal_type"
                    initialValue="individual"
                    style={{ flex: 1, minWidth: 260 }}
                  >
                    <Radio.Group>
                      <Radio value="on_total">On Bill Total</Radio>
                      <Radio value="individual">On Individual Item</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* Is Serial on Item? */}
                  <Form.Item
                    label="Is Serial on Item?"
                    name="serial_enabled"
                    initialValue="no"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* Is Bill Wise Collection? */}
                  <Form.Item
                    label="Is Bill Wise Collection?"
                    name="bill_wise_collection"
                    initialValue="no"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* Is Auto Challan? */}
                  <Form.Item
                    label="Is Auto Challan?"
                    name="auto_challan"
                    initialValue="no"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* Minus Stock Sales? */}
                  <Form.Item
                    label="Minus Stock Sales?"
                    name="minus_stock_sale"
                    initialValue="no"
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Radio.Group>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {/* File uploads */}
                  <Form.Item
                    label="Branch Logo"
                    name="branch_logo"
                    valuePropName="fileList"
                    getValueFromEvent={(e) =>
                      Array.isArray(e) ? e : e && e.fileList
                    }
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Upload
                      beforeUpload={() => false}
                      listType="picture-card"
                      accept="image/*"
                    >
                      <div>
                        <UploadOutlined />
                        <div style={{ marginTop: 8 }}>Logo</div>
                      </div>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Branch Stamp"
                    name="branch_stamp"
                    valuePropName="fileList"
                    getValueFromEvent={(e) =>
                      Array.isArray(e) ? e : e && e.fileList
                    }
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Upload
                      beforeUpload={() => false}
                      listType="picture-card"
                      accept="image/*"
                    >
                      <div>
                        <UploadOutlined />
                        <div style={{ marginTop: 8 }}>Stamp</div>
                      </div>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Branch Signature"
                    name="branch_signature"
                    valuePropName="fileList"
                    getValueFromEvent={(e) =>
                      Array.isArray(e) ? e : e && e.fileList
                    }
                    style={{ flex: 1, minWidth: 200 }}
                  >
                    <Upload
                      beforeUpload={() => false}
                      listType="picture-card"
                      accept="image/*"
                    >
                      <div>
                        <UploadOutlined />
                        <div style={{ marginTop: 8 }}>Signature</div>
                      </div>
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    label="Company Description"
                    name="branch_desc"
                    style={{ flex: 1, minWidth: 300 }}
                  >
                    <TextArea rows={3} />
                  </Form.Item>
                </div>
              </Card>
            )
          }
        </Form.Item>

        <div style={{ marginTop: 20 }}>
          <Button onClick={handleCancel} style={{ marginRight: 12 }}>
            Back
          </Button>

          {access_type == "WRITE" && (
            <>
              <Button
                type="primary"
                htmlType="submit"
                data-testid="branch-save-btn"
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </>
          )}
        </div>
      </Form>
    </div>
  );
};

export default CreateBranchForm;
